import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBQantLogomark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 329,
	height: 326,
	viewBox: "0 0 329 326",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M323.707 223.723C316.767 204.258 313.214 183.439 313.59 162.133C314.572 115.714 295.425 69.2947 257.549 37.1355C191.224 -19.2067 92.3324 -10.4475 36.6888 56.6849C-18.9757 123.817 -10.3219 223.913 56.0031 280.234C88.8416 308.12 129.665 320.073 169.255 316.858C190.806 314.89 212.9 317.09 233.803 323.353C261.082 330.568 291.265 321.935 310.58 298.62C328.452 277.06 332.528 248.413 323.707 223.723Z",
			fill: "#005AFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M71.0949 156.916C81.0029 185.393 96.0948 211.84 115.493 234.775C137.065 260.27 176.467 260.27 198.038 234.775C217.457 211.84 232.528 185.415 242.436 156.916C253.473 125.222 233.72 90.6929 201.09 84.5361C171.805 79.014 141.726 79.014 112.441 84.5361C79.8114 90.6929 60.0581 125.222 71.0949 156.916Z",
			fill: "#32C8DC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M227.217 160.195C219.065 136.752 206.69 115.023 190.721 96.151C172.974 75.184 140.575 75.184 122.807 96.151C106.837 115.023 94.4418 136.752 86.2687 160.195C77.1969 186.26 93.4384 214.654 120.278 219.731C144.358 224.28 169.128 224.28 193.208 219.731C220.047 214.675 236.31 186.26 227.217 160.195Z",
			fill: "white"
		})
	]
});
export default SvgBQantLogomark;
